import React, { useEffect, useRef } from "react";

import styled from "styled-components";

import useComponentSize from "../../hooks/useComponentSize";
import useModal from "../../hooks/useModal";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import { convertHex } from "../../services/colors-service";
import { Frame, TExtra } from "../ui-kit/styled-templates";

import { EModals } from "types/enums";

type TPopUp = {
    name: EModals;
    disableDarkOverlay?: boolean;
    extra?: TExtra;
    preventClosing?: boolean;
    withCros?: boolean;
    onClickOutside?: Function;
    onOpen?: Function;
    onClose?: Function;
    children?: React.ReactNode;
};

const ModalWrapper = (props: TPopUp) => {
    const {
        name,
        disableDarkOverlay = false,
        extra = ``,
        preventClosing = false,
        withCros = true,
        onClickOutside = () => {},
        onOpen = () => {},
        onClose = () => {},
    } = props;

    const { isOpened, shouldMount, open, close, setPreventClosing } = useModal(name, { onOpen, onClose });
    const ref = useRef();

    useEffect(() => setPreventClosing(preventClosing), [preventClosing]);

    const handleClose = (e: any) => {
        if (!(window.innerWidth - e.x < 7)) {
            onClickOutside?.();
            close();
        }
    };
    useOnClickOutside(ref, handleClose);

    const { height } = useComponentSize(ref, (props as any).children);

    useEffect(() => {
        document.getElementsByTagName(`body`)[0].style.overflowY = isOpened ? `hidden` : `auto`;
    }, [isOpened]);

    if (!shouldMount) {
        return null;
    }

    return (
        <>
            {!disableDarkOverlay ? <DarkOverlay isOpened={isOpened} /> : null}
            <OuterWrapper height={height} isOpened={isOpened}>
                <InnerWrapper isOpened={isOpened}>
                    <OpenProjectTab isOpened={isOpened} extra={extra} ref={ref}>
                        {withCros ? <Cross onClick={close} /> : null}
                        {props.children}
                    </OpenProjectTab>
                </InnerWrapper>
            </OuterWrapper>
        </>
    );
};

const InnerWrapper = styled(Frame)<{ isOpened: boolean; extra?: TExtra }>`
    visibility: ${({ isOpened }) => (isOpened ? `visible` : `hidden`)};
    opacity: ${({ isOpened }) => (isOpened ? 1 : 0)};
    display: flex;
    width: 100%;
    min-height: min-content;

    ${({ extra }) => extra}
`;

const OuterWrapper = styled(Frame)<{ isOpened: boolean; height: number; extra?: TExtra }>`
    visibility: ${({ isOpened }) => (isOpened ? `visible` : `hidden`)};
    opacity: ${({ isOpened }) => (isOpened ? 1 : 0)};
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
    flex: 1;
    display: flex;
    width: 100%;
    overflow: auto;
    justify-content: ${({ height }) => (height > window.innerHeight ? `flex-start` : `center`)};

    ${({ extra }) => extra}
`;

const Cross = styled.img.attrs(() => {
    let img;
    try {
        img = require(`../../assets/icons/close.svg`).default;
    } catch (error) {}
    return { src: img };
})`
    width: 24px;
    height: 24px;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 4;
    cursor: pointer;
    transition: 0.2s;
    &:hover {
        transform: rotate(90deg);
    }
`;

const OpenProjectTab = styled(Frame)<{ isOpened?: boolean }>`
    padding: 30px 30px;
    padding: 35px 30px;
    /* margin: 50px 0; */
    border-radius: 4px;
    background: ${({ theme }) => theme.background.primary};
    box-sizing: border-box;
    width: 100%;
    max-width: 800px;
    position: relative;

    transform: translate(0, ${({ isOpened }) => (isOpened ? `0` : `50px`)});

    visibility: ${({ isOpened }) => (isOpened ? `visible` : `hidden`)};
    opacity: ${({ isOpened }) => (isOpened ? 1 : 0)};

    @media only screen and (max-width: 600px) {
        min-width: auto;
        width: 90vw;
        padding: 8vw 5vw;
        transition: 0.2s;
    }

    ${(props) => props.extra}
`;

const DarkOverlay = styled(Frame)<{ isOpened: boolean }>`
    width: 100vw;
    height: 100vh;
    background: ${({ theme, isOpened }) => convertHex(theme.text.dark, +isOpened * 0.2)};
    visibility: ${({ isOpened }) => (isOpened ? `visible` : `hidden`)};
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
    /* backdrop-filter: blur(24px); */
`;

export default ModalWrapper;
